<template>
  <nav class="main" v-bind:class='{searchshowing: searchShowing, whitenav: whiteNav}'>
    <div class="menu-inner">
      <ul class="primary-links" v-if="!whiteNav">
        <li class="logo"><router-link :to="'/'"><img src="../assets/logo.png"></router-link></li>
        <li class="search">
            <i class="material-icons" @click='searchShowing = true'>search</i>
            <Autocomplete v-bind:class='{searchshowing: searchShowing}'' :searchPlaceholder="'Search'" @searchBlur='searchShowing = false' :autoFocus="searchShowing" :styling="'inheader'" @select='searchSelect' />
        </li>
        <!-- <li class="browse"><router-link :to="'/browse'"><i class="material-icons">apps</i> <span>Browse</span></router-link></li> -->
      </ul>
      <div class="secondary-links" v-if="!whiteNav">
        <ul class="contactlinks">
          <li class="phonenumber"><a href="tel:2133050464">213.305.0464</a></li>
          <li class="contactlink"><a href="mailto:renee@therenees.com">Email</a></li>
        </ul>
        <ul class="accountlinks">
          <li @click="$emit('accountClick')" class="account"><i class="material-icons mobile">person</i> <span>Account</span></li>
          <li @click="$emit('pullSheetClick')"><i class="material-icons mobile">photo_library</i> <i class="material-icons desktop">arrow_drop_down</i> <span>Pullsheet</span></li>
        </ul>
      </div>

      <ul class="primary-links" v-if="whiteNav">
        <li class="logo"><router-link :to="'/'"><img src="../assets/logo-purple.png"></router-link></li>
        <li class="search">
            <i class="material-icons" @click='searchShowing = true'>search</i>
            <Autocomplete v-bind:class='{searchshowing: searchShowing}'' @searchBlur='searchShowing = false' :autoFocus="searchShowing" :searchPlaceholder="'Search Our Properties'" :styling="'whitenav'" @select='searchSelect' />
        </li>
        <!-- <li class="browse"><router-link :to="'/browse'"><i class="material-icons">apps</i> <span>Browse</span></router-link></li> -->
      </ul>
      <div class="secondary-links" v-if="whiteNav">
        <ul class="sitelinks">
          <li><router-link :to="'/browse'">Our Properties</router-link></li>
          <li><router-link :to="'/about'">Our Story</router-link></li>
          <li><router-link :to="'/contact'">Contact</router-link></li>
        </ul>
        <ul class="accountlinks">
          <li @click="$emit('accountClick')" class="account"><i class="material-icons mobile">person</i> <span>Account</span></li>
          <li @click="$emit('pullSheetClick')"><i class="material-icons mobile">photo_library</i> <i class="material-icons desktop">arrow_drop_down</i> <span>Pullsheet</span></li>
        </ul>
      </div>

    </div>
  </nav>
</template>

<script>
import Autocomplete from './Autocomplete'
export default {
  name: 'MainMenu',
  props: [
    'userName',
    'whiteNav'
  ],
  data () {
    return {
      searchShowing: false,
      pullSheet: this.$root.pullSheet
    }
  },
  methods: {
    showSearch: function () {
    },
    searchSelect: function (option) {
      if (option.plcount !== undefined) {
        this.$router.push('/browse/' + option.slug)
        return false
      }
      if (option.reneeid !== undefined) {
        this.$router.push('/location/' + option.reneeid)
        return false
      }
      if (option.plno !== undefined) {
        this.$router.push('/location/' + option.reneeid)
        return false
      }
      if (option.properties !== undefined) {
        this.$router.push('/browse/building/' + option.slug)
        return false
      }
      this.searchShowing = false
    }
  },
  events: {
    addToPullSheet: function (data) {
    }
  },
  components: {
    Autocomplete
  },
  watch: {
    'pullSheet': {
      handler: function (val, oldVal) {
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
nav.main {
  position: fixed;
  z-index: 100;
  top: 0px;
  left: 0px;
  background: #7c4682;
  font-family: $lulo;
  width: 100%;
  height: 50px;
  text-transform: uppercase;
  @include noselect();
  @include bp(most) {
    height: 108px;
  }
  /* box-shadow:
    0px 1px 0px 0px #F5F4ED,
    0px 2px 0px 0px #D3D2CF; */
}
  img {
    width: 49px;
    height: 36px;
    @include bp(most) {
      width: 85px;
      height: 62px;
    }
  }

  ul.primary-links {
    float: left;
    font-weight: 600;
    li {
      line-height: 48px;
      a {
        text-decoration: none;
        color: $notblack;
      }
    }
    li.logo {
        @include bp(mobile) {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 6px;
        }
        @include bp(most) {
          padding: 18px 0 0 27px;
        }
    }
    li.search {
      margin-left: 16px;
      cursor: pointer;
      float: left;
      letter-spacing: -.2em;
      color: #b483c4;
      @include bp(medlarge) {
        margin-left: 42px;
      }
      @include bp(most) {
        margin-top: 31px;
        float: none;
        margin-left: 24px;
        font-size: 48px;
        .material-icons {
          font-size: 36px;
          margin-top: 4px;
          margin-right: -3px;
          @include bp(medlarge) {
            font-size: 48px;
            margin-top: -3px;
            margin-right: 3px;
          }
        }
      }
    }
    li.browse {
      margin-left: 4px;
      @include bp(most) {
        margin-left: 27px;
      }
    }
    .material-icons {
      font-size: 18px;
      vertical-align: middle;
      margin-top: 4px;
      margin-right: 3px;
    }
  }

  div.secondary-links {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #ac88b7;
    text-align: right;
    @include bp(most) {
      right: 20px;
    }
    @include bp(medlarge) {
      right: 40px;
    }
    ul.contactlinks {
      display: none;
      @include bp(most) {
        display: block;
      }
    }
    li {
      font-weight: 700;
      cursor: pointer;
      margin-left: 9px;
      @include bp(mobile) {
        &.account {
          margin-left: 4px;
        }
      }
      @include bp(most) {
        margin-left: 9px;
      }
      @include bp(medlarge) {

      }
      &.phonenumber {
        margin-right: 0;
        font-weight: 400;
        letter-spacing: -.2em;
        display: none;
        vertical-align: bottom;
        @include bp(most) {
          font-size: 28px;
          display: inline-block;
        }
        @include bp(medlarge) {
        }
      }
      &.contactlink {
        font-size: 32px;
        vertical-align: bottom;
        margin-left: 16px;
        @include bp(medlarge) {
          margin-left: 25px;
        }
      }
      .material-icons {
        font-size: 18px;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: -3px;
      }
    }
      ul.accountlinks {
        font-family: $noto;
        padding-right: 7px;
        font-size: 16px;
        letter-spacing: .1em;
      }
    a {
      text-decoration: none;
      color: #ac88b7;
      &:hover {
        color: #FFF;
      }
    }
  }

  ul, li {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    display: inline-block;
    vertical-align: top;
    span {
      display: none;
      @include bp(most) {
        display: inline;
      }
    }
  }

  nav.main.whitenav {
    background: #FFF;
   ul.sitelinks {
     display: none;
     @include bp(most) {
       display: block;
     }
   }
  }
  @include bp(most) {
    nav.main.whitenav {
      background: #FFF;
      box-shadow: none;
      color: #000;
      position: fixed;
      z-index: 999;
      height: 90px;
      box-sizing: border-box;
      text-transform: none;
      font-family: $futura;
      font-weight: 200;
      font-size: 18px;
      .phonenumber {
        font-weight: 600;
      }
      li.logo {
        padding: 14px 0 0;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      ul.accountlinks {
        display: none;
      }
      li.search {
        line-height: 0px;
        margin-top: 23px;
        position: relative;
        i {
          position: absolute;
          font-size: 18px;
          left: 9px;
          top: 46%;
          transform: translateY(-50%);
          @include bp(medlarge) {
            position: absolute;
            font-size: 24px;
            left: 8px;
            top: 55%;
          }
        }
        .autocomplete-input {
          @include bp(most) {
            width: 308px;
          }
          @include bp(medlarge) {
            width: 380px;
          }

        }
      }
      .secondary-links {
        right: 10px;
        display: none;
        display: block;
        li {
          border-left: 1px solid #777;
          line-height: 42px;
          margin: 0px;
          padding: 0 1em;
          font-size: 16px;
          @include bp(medlarge) {
            padding: 0 2em;
            font-size: 18px;
          }
          @include bp(large) {
            padding: 0 3em;
          &:last-child {
            padding-right: 2.5em;
          }

          }
          &:first-child {
            border-left: 0px none;
          }
        }
        a {
          color: #000;
          font-weight: 200;
          text-transform: none;
          &:hover {
            color: purple;
          }
        }
      }
    }
  }

  .autocomplete-input.stretch-enter-active {
    transition: all .5s;
  }
  .autocomplete-input.stretch-enter {
    opacity: 0;
    width: 54px;
  }
  div.autocomplete-input {
    opacity: 1;
    width: 100%;
    display: none;
    box-sizing: border-box;
    width: 100%;
    &.searchshowing {
      display: inline-block;
    }
    @include bp(mobile) {
      position: absolute;
      left: 0px;
      top: 50px;
      padding: 4px 8px;
      background: #aa89b7;
      z-index: 1001;
    }
    @include bp(most) {
      display: inline-block;
      width: 250px;
      height: 48px;
    }
  }

  i.mobile {
    display: inline-block;
    @include bp(most) {
      display: none;
    }
  }
  i.desktop {
    display: none;
    @include bp(most) {
      display: inline-block;
    }
  }

  @include bp(mobile) {
    nav.main.searchshowing {
      ul li {
        /* display: none; */
      }
      ul li.search {
        /* display: inline-block; */
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MainMenu.vue?570d8f6c